<template>
  <ClientOnly>
    <div class="ao__twitter-container">
      <DefaultExternalTwitterEmbed
        v-if="!tweetError"
        :tweet-url="src"
        cards="visible"
        conversation="all"
        lang="cs"
        theme="light"
        align="center"
        width="auto"
        :dnt="false"
        @tweet-load-error="onTweetLoadError"
        @tweet-load-success="onTweetLoadSuccess"
      >
        <template #loading />
        <template #error />
      </DefaultExternalTwitterEmbed>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

const props = defineProps<{
  type?: string
  payload?: any
  parentIdent?: string
}>()

const src = computed<string>(() => props.payload?.attributes?.src ?? '')

const tweetError = ref<Error | null>(null)

function onTweetLoadError(error: Error) {
  tweetError.value = error
}

function onTweetLoadSuccess(_el: HTMLDivElement) {
  tweetError.value = null
}
</script>

<style lang="postcss" scoped>
.ao__twitter-container {
  @apply my-6 w-full;
}

.ao__twitter-container :deep(.twitter-tweet),
.ao__twitter-container :deep(.twitter-tweet-rendered),
.ao__twitter-container :deep(iframe) {
  width: min(100%, 540px) !important;
  max-width: 540px !important;
  min-width: 0 !important;
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
